<div class="Box-No-Shadow  agreements padding-left-15px padding-top-15px padding-right-15px">
  <div class="card my-profile-form skillassest-form border-radius-top-right">
    <div class="card-body bk-color-sky border-radius-top-right padding-top padding-left-0px padding-right-0px margin-left-0px padding-bottom-0px">
      <div class="row margin-left-0px margin-right-0px">
        <!--<label *ngIf="isGraphLoading">Please wait, refreshing...</label>-->
        <div class="col-md-12 padding-left-0px padding-right-0px">


          <h4 class="margin-left-10px font-weight-bold margin-bottom-10px margin-top-10">
            {{ReportType}}
            <!--<a (click)="TableView()" class="nav-link-hand" title="Tabular view"><i class="fas fa-table"></i></a>-->
          </h4>
        </div>
        <div class="row col-md-12 bk-color-sky padding-left-0px padding-right-0px margin-left-0px margin-right-0px">
          <div class="col-md-12 padding-left-0px padding-right-0px">
            <!--<a (click)="TableView()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here to vie graph data">Table </a>-->
            <div class="accordion" [id]="'accordionExample'+ReportType" hidden>
              <div class="card margin-bottom-5px card-background-transparent">
                <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0  padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" [id]="'heading'+ReportType">
                  <div class="row">
                    <div class="col-md-12 text-align-center">

                      <button class="btn font-size-29px padding-top-0px line-height-new background-norepeat padding-right-0px padding-left-0px" type="button" data-toggle="collapse" attr.data-target="#collapse{{ReportType}}" aria-expanded="true" [attr.aria-controls]="'collapse'+ReportType">
                        ..
                      </button>

                    </div>

                  </div>


                </div>

                <div [id]="'collapse'+ReportType" class="collapse" [attr.aria-labelledby]="'heading'+ReportType" [attr.data-parent]="'#accordion'+ReportType">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row margin-left-0px margin-right-0px">
                      <!--[style.background-color]="changeBackground(p)"-->
                      <div class="badge badge-graph-background width-auto height-auto margin-right-5px margin-left-5px margin-bottom-5px"
                           [style.background-color]="changeBackground(p)"
                           *ngFor="let p of MisReportXYControllerData">
                        <div class="row">

                          <div class="col-md-12 padding-left-10px text-align-left">
                            <label class="margin-bottom-0px font-size-14px font-weight-bold "
                                   style="color: white!important;">{{p.xName}}</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px  font-size-18px data-color-white">
                              {{p.yValue}}
                            </h4>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-12 padding-left-0px padding-right-0px">
              <div class="row margin-left-0px margin-right-0px padding-all-5px" *ngIf="MisReportXYControllerData">
            
                  <div *ngFor="let p of MisReportXYControllerData" class="col-md-4 col-6 mistable-data">
                    <div class="col-md-12 border-radius-10 bk-color-sky padding-all-5px">
                      <div class="text-align-left margin-left-0px misdatafont">
                        {{p.yValue | number:'1.0-0'}}
                      </div>
                      <div class="row col-md-12 padding-left-0px padding-right-0px margin-left-0px margin-right-0px font-size-12px font-weight-bold wrap-text">
                        {{p.xName}}
                      </div>
                      
                    </div>
                  </div>
                
                

                <table class="table table-striped margin-left-zero" hidden>


                  <tbody class="table-body">
                  
                    <tr *ngFor="let p of MisReportXYControllerData">



                      <td class="padding-top-0px padding-bottom-0px">{{p.xName}}</td>

                      <td class="padding-top-0px padding-bottom-0px"> {{p.yValue | number:'1.0-0'}}</td>





                    </tr>



                  </tbody>




                </table>

              </div>
              <div class="row margin-left-0px margin-right-0px padding-all-5px" *ngIf="!MisReportXYControllerData || MisReportXYControllerData.length == 0">
                <div>
                  No Data Available
                </div>
              </div>
            </div>

          </div>
        </div>

 

      </div>
    </div>


  </div>


</div>

